// extracted by mini-css-extract-plugin
export var container = "recipe-description-module--container--NpsgV";
export var ingredients = "recipe-description-module--ingredients--Wt-KB";
export var method = "recipe-description-module--method--psmKd";
export var title = "recipe-description-module--title--FT-YC";